const AllocationMisToolbar = () => (
  <div className="allocation-mis-toolbar">
    <span className="allocation-mis-toolbar__title">Allocation MIS</span>
  </div>
);

export default AllocationMisToolbar;
